import React from "react"
import { Col, Row, Icon as AIcon } from "antd"
import { MoreIcon, CheckedIcon } from "../core/icons"
import { Image } from "react-bootstrap"
import Card from "../core/Card"

const PremiumFeatures = props => (
  <Row>
    <h1>Why Everlance Premium?</h1>

    <Col md={12} sm={24} xs={24}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Image
          style={{ height: 40, margin: 20 }}
          className="image-left-of-text"
          src="https://s3.amazonaws.com/everlance-dashboard/assets/images/Convertible-100.png"
          responsive
        />
        <p>
          <h4>Pays for itself after 1 big trip per month</h4>
          Every 1,000 miles is worth $545 in deductions.
        </p>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Image
          style={{ height: 40, margin: 20 }}
          className="image-left-of-text"
          src="https://s3.amazonaws.com/everlance-dashboard/assets/images/Banknotes-100.png"
          responsive
        />

        <p>
          <h4>Save $ Thousands on Taxes</h4>
          Premium users identify over $3,500 in tax deductions per year on
          average.
        </p>
      </div>
    </Col>
    <Col md={12} sm={24} xs={24}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Image
          style={{ height: 40, margin: 20 }}
          className="image-left-of-text"
          src="https://s3.amazonaws.com/everlance-dashboard/assets/images/Past-100.png"
          responsive
        />

        <p>
          <h4>Save hours of your valuable time</h4>
          Manually tracking miles is a waste of time. Let Everlance do the work
          for you.
        </p>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Image
          style={{ height: 40, margin: 20 }}
          className="image-left-of-text"
          src="https://s3.amazonaws.com/everlance-dashboard/assets/images/Refund+2-100.png"
          responsive
        />

        <p>
          <h4>100% Tax Deductible</h4>
          The cost of Everlance Premium is tax deductible, making it even more
          affordable.
        </p>
      </div>
    </Col>
  </Row>
)
export default PremiumFeatures



// WEBPACK FOOTER //
// ./src/subscriptions/PremiumFeatures.jsx